<script setup lang="ts">
import { SearchIcon } from '@fond-of/satch-icons'

const props = defineProps<{
  disabled?: boolean | undefined
}>()
</script>

<template>
  <button
    :class="[
      'bg-gray-ultra-light text-black',
      'inline-flex items-center justify-center',
      'h-[46px] w-[46px] border-none md:h-[52px] md:w-[52px]',
      'group-has-[:focus]:bg-black group-has-[:focus]:outline-black',
      'group-has-[:focus]:text-white group-has-[:focus]:outline group-has-[:focus]:-outline-offset-2',
    ]"
    data-slot="icon"
    :disabled="props.disabled"
    aria-label="Search Button"
  >
    <SearchIcon class="-ml-0.5 size-[28px] md:size-[26px]" />
  </button>
</template>
